import React from 'react'
import { OktaAuthnResponse } from '@hooks/useOkta'
import { IAuthenticationService } from '../../services/AuthService/IAuthService'
import { TMkAuthenticationAction, TMkAuthenticationState, IMkAuthorizedSession } from '../../types'

export interface IMkAuthenticationServiceContext extends TMkAuthenticationState {
  authService: IAuthenticationService
  isSharedSessionSyncInProgress: boolean
  dispatchAuthenticationAction: React.Dispatch<TMkAuthenticationAction>
  login: ({ username, password }: { username: string; password: string }) => Promise<void>
  loginWithToken: (token: string, isActivation: boolean) => Promise<OktaAuthnResponse>
  onLoginCallback: (onAuthorizedSession: (session: IMkAuthorizedSession) => void, onFailedToAuthorize: (error?: Error) => void) => Promise<void>
  logout: () => Promise<void>
  switchMembership: (memberNumber: string) => Promise<void>
  checkSession: () => Promise<void>
  refreshSession?: () => Promise<void>
  refreshMakoAuthorizationTokens?: () => Promise<void>
}

export const AuthenticationContext = React.createContext<IMkAuthenticationServiceContext>({} as IMkAuthenticationServiceContext)
